module.exports = __webpack_public_path__ + "812cf5df7e204ffc9a3a483ce8cfe2b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/testimonials-hero.jpg
// module id = 29
// module chunks = 0